// External Dependencies:
import React from 'react'
import ReactDOM from 'react-dom'
import keycode from 'keycode'

// Internal Dependencies:
import getYouTubeId from 'utilities/video'

class ImageSliderModal extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isOpen: props.isOpen,
			slidesCount: props.images.length,
			activeSlide: props.activeSlide || 1
		}

		this.root = document.getElementById( 'safe-rescue-image-slider-modal' )
		this.el = document.createElement( 'div' )
	}

	static defaultProps = {
		cancel: () => null
	}

	componentDidMount() {
		this.root.appendChild( this.el )
		document.documentElement.classList.add( 'with-image-slider-modal-open' )
		document.addEventListener( 'mousedown', this.handleClickOutside )
		document.addEventListener( 'keydown', this.handleKeyPress )
	}

	componentWillUnmount() {
		this.root.removeChild( this.el )
		document.documentElement.classList.remove( 'with-image-slider-modal-open' )
		document.removeEventListener( 'mousedown', this.handleClickOutside )
		document.removeEventListener( 'keydown', this.handleKeyPress )
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( this.props.isOpen != prevProps.isOpen ) {
			this.setState({
				isOpen: this.props.isOpen
			})
		}
	}

	handleClickOutside = ( e ) => {
		if ( this.outside == e.target ) {
			this.handleCancel()
		}
	}

	handleKeyPress = ( e ) => {
		if ( 'esc' == keycode( e ) ) {
			this.handleCancel()
		}
	}

	handleCancel = () => {
		this.props.cancel()
	}

	selectPrev = () => {
		const { slidesCount, activeSlide } = this.state

		this.setState({
			activeSlide: activeSlide == 1 ? slidesCount : activeSlide - 1
		})
	}

	selectNext = () => {
		const { slidesCount, activeSlide } = this.state

		this.setState({
			activeSlide: activeSlide == slidesCount ? 1 : activeSlide + 1
		})
	}

	render() {
		const { images } = this.props
		const { isOpen, activeSlide } = this.state
		const className = isOpen ? 'image-slider-modal modal is-open' : 'image-slider-modal modal is-closed'

		if ( ! images || ! images.length ) {
			return null
		}

		let imageSliderMarkup = images.map( ( url, i ) => {
			let className = activeSlide == ( i + 1 ) ? 'is-active' : ''

			if ( url.indexOf( 'youtu' ) != -1 ) {
				className += ' slider-video'
				let videoId = getYouTubeId( url )
				let iframeSrc = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&amp;showinfo=0`

				return (
					<div
						key={ url }
						className={ className }
						src={ url }
					>
						<iframe src={ iframeSrc } frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen />
					</div>
				)
			} else {
				return (
					<img
						key={ url }
						className={ className }
						src={ url }
						alt=""
					/>
				)
			}
		})

		const markup = (
			<div className={ className } ref={ ( e ) => { this.outside = e } } onClick={ this.handleClickOutside } tabIndex="0">
				<div className="modal-inner">
					<div className="image-slider">
						{ imageSliderMarkup }

						<nav>
							<i className="-back icon-chevron-down" onClick={ this.selectPrev }></i>
							<i className="-forward icon-chevron-down" onClick={ this.selectNext }></i>
							<i className="-close icon-close" onClick={ this.handleCancel }></i>
						</nav>
					</div>
				</div>
			</div>
		)

		return ReactDOM.createPortal(
			markup,
			this.el,
		)
	}
}

export default ImageSliderModal



// WEBPACK FOOTER //
// ./components/slider/slider-modal.jsx